import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, isKnownHost } from 'shared/config/firebase';
import { RootLayout } from 'shared/layout/RootLayout';
import jwtAuthStore from 'shared/store/jwtAuthStore';

import { StreetBeatChatProvider } from 'shared/providers/StreetBeatChatProvider';

export const ProtectedRoute: React.FC = () => {
  const [ready, setReady] = useState(false);
  const navigate = useNavigate();
  // Use the hook pattern to subscribe to store changes
  const { shouldUseJwt, isVerified } = jwtAuthStore();

  useEffect(() => {
    // Check if we're on a known host
    const isOnKnownHost = isKnownHost();

    // Special handling for known hosts
    if (isOnKnownHost) {
      // If JWT is being used and verified, we're authenticated
      if (shouldUseJwt && isVerified) {
        setReady(true);
        return;
      }

      // If we're on a known host but don't have a valid token, redirect to the JWT required page
      setReady(true);
      navigate('/jwt-auth-required');
      return;
    }

    // For non-known hosts, use Firebase authentication
    auth.onAuthStateChanged((user) => {
      setReady(true);
      if (!user) {
        navigate('/');
      }
    });
  }, [navigate, shouldUseJwt, isVerified]); // Add these dependencies to react to changes

  if (!ready) return null;

  return (
    <>
      <StreetBeatChatProvider>
        <RootLayout />
      </StreetBeatChatProvider>
    </>
  );
};
